import api from './api';

import {CHANNELS_SET_ACTIVE} from './channels';

export const CART_SET = 'CART_SET';

export default function reducer(state = null, {type, payload}) {
  switch (type) {
    case CART_SET:
      return payload;
    case CHANNELS_SET_ACTIVE:
      return null;
    default:
      return state
  }
}

export function setCart(cart) {
  return {type: CART_SET, payload: cart};
}

const extractCartItems = items => items.map(item => ({
  variant: item.variant.id,
  quantity: item.quantity,
  options: item.options.map(option => option.optionId),
  rankRangeStart: item.rankRangeStart,
  rankRangeEnd: item.rankRangeEnd,
  event: item.event && item.event.id,
  eventOccurrence: item.eventOccurrence
}));

const mapCartItems = products => products.map(product => ({
  ...product,
  options: product.options.map(optionId => ({option: optionId}))
}));

export function getCart(cartId, cartToken = undefined) {
  return dispatch => dispatch(api.get(`carts/by-id/${cartId}`, {cartToken}))
    .then(cartResponse => {
      dispatch(setCart(cartResponse.content));

      return cartResponse;
    });
}

export function createCart(products) {
  return dispatch => dispatch(api.post('carts/', {items: mapCartItems(products)}))
    .then(cartResponse => {
      dispatch(setCart(cartResponse.content));

      return cartResponse;
    });
}

export function updateCart(cartId, newProducts, cartToken = undefined) {
  return dispatch => dispatch(api.post(`carts/by-id/${cartId}`, {items: mapCartItems(newProducts)}, {cartToken}))
    .then(cartResponse => {
      dispatch(setCart(cartResponse.content));

      return cartResponse;
    });
}

export function deleteCart(cartId, cartToken = undefined) {
  return dispatch => dispatch(api.delete(`carts/by-id/${cartId}`, undefined, {cartToken}))
    .then(() => dispatch(setCart(null)));
}

export function addProductToCart(product) {
  return (dispatch, getState) => {
    const currentCart = getState().cart;

    return dispatch(currentCart
      ? updateCart(currentCart.id, extractCartItems(currentCart.items).concat(product), currentCart.tokenValue)
      : createCart([product])
    )
      .then(cartResponse => {
        const addedItem = cartResponse.content.items.slice().reverse()
          .find(cartItem => cartItem.variant.id === product.variant);

        // if (addedItem) {
        //   dispatch(analyticsProductAdded(addedItem));
        // }

        return cartResponse;
      });
  }
}

export function removeProductFromCart(cartItemId) {
  return (dispatch, getState) => {
    const currentCart = getState().cart;
    const removedItem = currentCart.items.find(item => item.id === cartItemId);
    const newCartItems = currentCart.items.filter(item => item.id !== cartItemId);

    return dispatch(newCartItems.length
      ? updateCart(currentCart.id, extractCartItems(newCartItems), currentCart.tokenValue)
      : deleteCart(currentCart.id, currentCart.tokenValue)
    ).then(cartResponse => {
      // if (removedItem) {
      //   dispatch(analyticsProductRemoved(removedItem));
      // }

      return cartResponse;
    });
  }
}

export function applyCouponToCart(promotionCoupon, cartId, cartToken) {
  return dispatch => dispatch(api.post(`carts/by-id/${cartId}/coupon`, {promotionCoupon}, {cartToken}))
    .then(couponResponse => dispatch(setCart(couponResponse.content)));
}

export function removeCouponFromCart(cartId, cartToken) {
  return dispatch => dispatch(api.delete(`carts/by-id/${cartId}/coupon`, undefined, {cartToken}))
    .then(couponResponse => dispatch(setCart(couponResponse.content)));
}

export function checkoutCart(cartId, paymentMethod, checkoutFields, affiliateCode, cartToken) {
  return dispatch => dispatch(api.post(
    `carts/by-id/${cartId}/checkout`,
    {
      payments: [{method: paymentMethod}],
      ...checkoutFields,
      tos_accepted: checkoutFields.tos_accepted ? '1' : undefined,
      newsletter_subscribed: checkoutFields.newsletter_subscribed ? '1' : undefined,
      affiliate_code: affiliateCode
    },
    {cartToken}
  )).then(checkoutResponse => {
    // dispatch(analyticsCheckoutPayment(checkoutResponse.content, paymentMethod));

    return checkoutResponse;
  });
}

export function claimCartOwnership(cartId, cartToken) {
  return dispatch => dispatch(api.post(`carts/by-id/${cartId}/ownership`, undefined, {cartToken}));
}

export function cleanupCartOwnership(cartId) {
  return dispatch => dispatch(api.delete(`carts/by-id/${cartId}/ownership`));
}

export function mergeCarts(mainCart, ...mergedCarts) {
  return dispatch => dispatch(api.post(`carts/by-id/${mainCart.id}/merge`, {
    merged: mergedCarts.map(cart => ({id: cart.id, token: cart.tokenValue}))
  }, {cartToken: mainCart.tokenValue}));
}

export function retrievePersistedCart(source) {
  return (dispatch, getState) => {
    const {channels} = getState();

    let carts;
    try {
      carts = JSON.parse(source);
    } catch (e) {
      carts = {};
    }

    if (carts[channels.activeChannel]) {
      const {id, token} = carts[channels.activeChannel];

      return dispatch(getCart(id, token));
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./ducks/cart.js